import { render, staticRenderFns } from "./AutoParams.vue?vue&type=template&id=2de4bede"
import script from "./AutoParams.vue?vue&type=script&lang=js"
export * from "./AutoParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports